/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GenerateTitleResponseBody = {
  /**
   * The current title after the operation (empty when reset to auto-generated)
   */
  title: string;
};

/** @internal */
export const GenerateTitleResponseBody$inboundSchema: z.ZodMiniType<
  GenerateTitleResponseBody,
  unknown
> = z.object({
  title: z.string(),
});

export function generateTitleResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GenerateTitleResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GenerateTitleResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GenerateTitleResponseBody' from JSON`,
  );
}
